import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetTokenBalanceQuery } from "../../app/features/apiSlice";
import Loader from "../Loader";
import Error from "../Error";

const TokenBalance = () => {
  const { t } = useTranslation();
  const sessionId = useRef(Date.now()).current;
  const { data, isLoading, isError, error } = useGetTokenBalanceQuery({
    sessionId,
  });

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;
  return (
    <Card bg="dark1 text-light mb-2">
      <Card.Body>{t("tokenBalance")} : {data?.data[0]?.balance || 0}</Card.Body>
    </Card>
  );
};

export default TokenBalance;
